import { SOURCE_META } from "@/lib/api";

export const SourceBadge = ({ source, testId }) => {
  const m = SOURCE_META[source] || SOURCE_META.none;
  return <span className={`mono-badge ${m.cls}`} data-testid={testId}>{m.label}</span>;
};
